import React from 'react';
import PilarLayout from './PilarLayout';

/**
 * Dashboard do pilar (Vitalidade, Mentalidade ou Prosperidade).
 * Usa o layout padrão PilarLayout para manter UX consistente entre os 3 pilares.
 */
export default function PillarDashboard({
  pillarId,
  habits = [],
  goals = [],
  challenges = [],
  events = [],
  customColors,
  onNavigate,
}) {
  return (
    <PilarLayout
      pillarId={pillarId}
      habits={habits}
      goals={goals}
      challenges={challenges}
      customColors={customColors}
      onNavigate={onNavigate}
      loadNotesFromFirestore
    />
  );
}
